'use client';

import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';

export type TabNavItem = {
  label: string;
  href: string;
  isActive: boolean;
};

type Props = {
  ariaLabel: string;
  items: TabNavItem[];
  className?: string;
};

// Tab-styled links for switching between pages. Use a tablist for content that switches in place.
// Keep it mounted across those pages (e.g. in a layout) so the indicator can slide between them.
export function TabNav({ ariaLabel, items, className }: Props) {
  const activeIndex = items.findIndex(({ isActive }) => isActive);

  return (
    <nav aria-label={ariaLabel} className={clsx(styles.tabNav, className)}>
      <ul
        className={styles.list}
        style={
          {
            '--tab-count': items.length,
            '--active-index': activeIndex,
          } as React.CSSProperties
        }
      >
        {items.map(({ label, href, isActive }) => (
          <li key={href}>
            <ExtendedLink
              href={href}
              aria-current={isActive ? 'page' : undefined}
              className={styles.link}
            >
              <Body as="span" variant={isActive ? 'sm-bold' : 'sm-regular'}>
                {label}
              </Body>
            </ExtendedLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
